import { NormalizedUnloadingPackageGroup, PackageStockStatus } from "api/wms/models";
import { Tag } from "components/miloDesignSystem/atoms/tag";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { useCreateTableColumns } from "utilities/tableColumnsUtilities/createTableColumns/createTableColumns";
import { unloadingPackageGroupStatusDict } from "./LineItemsDetailsModal";
import { dateFns } from "utilities";
import { Avatar } from "components/miloDesignSystem/atoms/avatar";

export const useLineItemsDetailsColumns = () =>
  useCreateTableColumns<NormalizedUnloadingPackageGroup>(({ columnHelper }) => {
    return [
      columnHelper.accessor(row => row.name, {
        header: "nazwa paczki",
        size: 330,
        cell: info => {
          const name = info.getValue();
          const isNested = info.row.depth;
          return (
            <Typography
              color={isNested ? "neutralBlack88" : "neutralBlack48"}
              fontSize="12"
              fontWeight="700"
              noWrap
            >
              {name || "---"}
            </Typography>
          );
        },
      }),
      columnHelper.accessor(row => row.location, {
        header: "lokalizacja",
        size: 100,
        cell: info => {
          const isNested = info.row.depth;
          if (!isNested) return null;
          return (
            <Typography fontSize="14" fontWeight="700">
              {info.getValue() || "---"}
            </Typography>
          );
        },
      }),
      columnHelper.accessor(row => row.stockStatus, {
        header: "status",
        size: 120,
        cell: info => {
          const status: PackageStockStatus = info.getValue();
          const isNested = info.row.depth;
          if (!isNested) return null;
          return (
            <Tag
              label={unloadingPackageGroupStatusDict[status].label}
              variant={unloadingPackageGroupStatusDict[status].variant}
            />
          );
        },
      }),
      columnHelper.accessor(row => row.addedToStockAt, {
        id: "when",
        header: () => (
          <Typography
            className="text-right w-100"
            color="neutralBlack48"
            fontSize="12"
            fontWeight="400"
          >
            kiedy?
          </Typography>
        ),
        size: 110,
        cell: info => {
          const isNested = info.row.depth;
          if (!isNested) return null;
          return (
            <Typography className="text-right w-100" fontSize="12" fontWeight="700">
              {info.getValue()
                ? dateFns.formatRelative(new Date(info.getValue()), "dd.MM.yyyy, H:mm")
                : "---"}
            </Typography>
          );
        },
      }),
      columnHelper.accessor(row => row.collaborator, {
        header: "kto?",
        size: 26,
        cell: info => {
          const isNested = info.row.depth;
          const collaborator = info.getValue();
          if (!isNested) return null;
          if (Array.isArray(collaborator) && collaborator.length === 0)
            return <Avatar size="sm" theme="light" user={null} />;
          return (
            <div className="d-flex align-items-center pb-1">
              <Avatar size="sm" theme="light" user={collaborator} />
            </div>
          );
        },
      }),
    ];
  });
